// eslint-disable-next-line @typescript-eslint/no-unused-vars
function gtag(...args: any) {
  window['dataLayer'].push(arguments)
}

function event(name) {
  gtag('event', name)
}

function init(configurationId) {
  window['dataLayer'] = window['dataLayer'] || []
  gtag('js', new Date())
  gtag('config', configurationId)

  const script = document.createElement('script')
  script.src = `https://www.googletagmanager.com/gtag/js?id=${configurationId}`
  document.head.appendChild(script)
}

export default { init, event }
